import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetStatementEditorV2 } from './useGetStatementEditorV2'
import { StatementEditorV2Content } from './StatementEditorV2Content'

export const StatementEditorV2Component = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetStatementEditorV2(id, tileFilterSelections)

  return (
    <StatementEditorV2Content
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function StatementEditorV2ComponentLoading() {
  return 'Loading...'
}
